import { Injectable } from "@angular/core";
import { Constants } from "../utils/constants";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { UtilsService } from "./utils.service";
import { ApiResponse } from "../classes/api-response";
import { map } from "rxjs/operators";
import { Contract } from "../model/contract";
import { InvoiceSetup } from "../model/invoiceSetup";
import { InvoiceSetupItemArray } from "../model/invoiceSetupItemArray";
import { InvoiceItems } from "../model/invoiceItems";
import { Items } from "../model/items";

@Injectable({
  providedIn: 'root'
})
export class InvoiceSetupService {
  private readonly roles = Constants.roles;
  private readonly entities = Constants.entities;
  private readonly crtlPathFragment = this.entities.contracts;
  private readonly crtlFullPath = `${environment.apiUrl}/${this.crtlPathFragment}`;
  private readonly ctrlFullPathLS = `${environment.apiUrl}/invoice/createItemInvoiceAndSendMail`;
  private readonly ctrlFullPathINv = `${environment.apiUrl}/all-invoice-items`;
  private readonly ctrlFullPathUpdateInv = `${environment.apiUrl}/updateInvoiceSetup`;
  private readonly ctrlFullPathDelete = `${environment.apiUrl}/deleteInvoiceSetup`;
  private readonly ctrlFullPathSendMail = `${environment.apiUrl}/invoice/SendMail`;
  private readonly ctrlFullPathCreatePDF = `${environment.apiUrl}/invoice/prepareDataForPDF`;
  private readonly ctrlFullPathBoxes = `${environment.apiUrl}/contracts`;


  constructor(private http: HttpClient) {
  }

  /* public getAllSystemLogs(statuses?: string[]): Observable<SystemLogs[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
.get<ApiResponse>(`${this.crtlFullPath}`, {params})
       .pipe(map(value => value.data as SystemLogs[]));
  } */

  public getAllContracts(statuses?: string[]): Observable<Contract[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}`, { params })
      .pipe(map(value => value.data as Contract[]));
  }
  public getAllItemInvoice() {
    return this.http.get<ApiResponse>(`${this.ctrlFullPathINv}`)
      .pipe(map(value => value.data as InvoiceSetup[]
      ))
  }

  public getAllItemInvoiceByCompany(companyId?: number) {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.entities.companies}/${companyId}/invoiceItems`)
      .pipe(map(value => value.data as InvoiceSetup[]
      ))
  }

  public getContractById(contractId?: number | string, statuses?: string[]): Observable<Contract> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${contractId}`, { params })
      .pipe(map(value => value.data as Contract));
  }

  public createInvoiceSetup(invoiceSetup: InvoiceSetup, invoiceItems: InvoiceItems, idContract?: number, statuses?: string[]): Observable<InvoiceSetupItemArray> {
    //const headers = { 'Accept-Encoding' : 'gzip, deflate, br', 'Connection' : 'keep-alive', 'Content-Type' : 'application/json' };
    const headers = { 'Content-Type': 'application/json' };

    const invoiceSetupItemsArray = '{ "invoiceSetup": ' + JSON.stringify(invoiceSetup) + ', "invoiceItems": ' + JSON.stringify(invoiceItems) + '}';
    console.log(invoiceSetupItemsArray);
    return this.http
      .post<any>(`${this.ctrlFullPathLS}/${idContract}`, invoiceSetupItemsArray, { headers })
      .pipe(map(value => value.data as InvoiceSetupItemArray));
  }

  public getAllItemsDeliveredByContract(contractId?: number | string, statuses?: string[]) {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.ctrlFullPathBoxes}/${contractId}/boxes`, { params })
      .pipe(map(value => value.data));
  }

  public updateInvoice(invoiceSetup: InvoiceSetup): Observable<InvoiceSetupItemArray> {
    return this.http
      .post<ApiResponse>(`${this.ctrlFullPathUpdateInv}/${invoiceSetup.id}`, invoiceSetup)
      .pipe(map((value => value.data as InvoiceSetupItemArray)));
  }

  public deleteInvoiceSetup(id: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${this.ctrlFullPathDelete}/${id}`)
      .pipe(map(() => {
      }));
  }

  public sendNotificationForPayment(id: number, invoiceSetup: InvoiceSetupItemArray): Observable<void> {
    return this.http
      .post<ApiResponse>(`${this.ctrlFullPathSendMail}/${id}`, invoiceSetup)
      .pipe(map(() => {
      }));
  }

  public createPDF(id?: number | string, statuses?: string[]): Observable<InvoiceSetupItemArray> {
    const params = UtilsService.buildUrl(statuses);

    return this.http
      .get<ApiResponse>(`${this.ctrlFullPathCreatePDF}/${id}`, { params })
      .pipe(map((value => value.data as InvoiceSetupItemArray)));


  }
}